export const RateBoardMsgProps = {
    mir: 'nxi.rateboard.mir',
    error: 'nxi.rateboard.error',
    maintenanceError: 'nxi.rateboard.maintenanceError',
    tryAgain: 'nxi.rateboard.tryAgain',
    reference: 'nxi.rateboard.reference',
    moneyMarket: 'nxi.rateboard.moneyMarket',
    asOf: 'nxi.rateboard.asOf',
    fundName: 'nxi.rateboard.fundName',
    currentYield: 'nxi.rateboard.currentYield',
    dayYield: 'nxi.rateboard.dayYield',
    backToTop: 'nxi.rateboard.backToTop',
    backToTopUrl: window.location.href.split('#')[0] + '#backToTop',
    moneyMarketRates: 'nxi.rateboard.moneyMarketRates',
    sevenDayYield: 'nxi.rateboard.sevenDayYield',
    bankDeposit: 'nxi.rateboard.bankDeposit',
    tier: 'nxi.rateboard.tier',
    currentApy: 'nxi.rateboard.currentApy',
    currencyRates: 'nxi.rateboard.currencyRates',
    securities: 'nxi.rateboard.securities',
    description: 'nxi.rateboard.description',
    current: 'nxi.rateboard.current',
    money: 'nxi.rateboard.money',
    percentage: 'nxi.rateboard.percentage',
    interestRates: 'nxi.rateboard.interestRates',
    currentYieldAsof: 'nxi.rateboard.currentYieldAsof',
    margin: 'nxi.rateboard.margin',
    amount: 'nxi.rateboard.amount',
    lendingRate: 'nxi.rateboard.lendingRate',
    pblr: 'nxi.rateboard.pblr',
    stock: 'nxi.rateboard.stock',
    optionIndices: 'nxi.rateboard.optionIndices',
    close: 'nxi.rateboard.close',
    change: 'nxi.rateboard.change',
    noChange: 'nxi.rateboard.noChange',
    commodities: 'nxi.rateboard.commodities',
    currencyCalculator: 'nxi.rateboard.currencyCalculator',
    enterCurrency: 'nxi.rateboard.enterCurrency',
    currentCurrency: 'nxi.rateboard.currentCurrency',
    toConvertCurrency: 'nxi.rateboard.toConvertCurrency',
    currentCurrencyAmount: 'nxi.rateboard.currentCurrencyAmount',
    convertedCurrencyAmount: 'nxi.rateboard.convertedCurrencyAmount',
    selectCurrency: 'nxi.rateboard.selectCurrency',
    equals: 'nxi.rateboard.equals',
    newCurrencyAmount: 'nxi.rateboard.newCurrencyAmount',
    disclaimer: 'nxi.rateboard.disclaimer',
    disclaimer1: 'nxi.rateboard.disclaimer1',
    disclaimer2: 'nxi.rateboard.disclaimer2',
    calculate: 'nxi.rateboard.calculate',
    pagedesc: 'nxi.rateboard.pagedesc',
    heading: 'nxi.rateboard.heading',
    selectCurrencyModern: 'nxi.modernRateboard.selectCurrency',
    currencyCalculatorModern: 'nxi.modernRateboard.selectCurrency',
    currencyRatesModern: 'nxi.modernRateboard.currencyRates'
};
